import { Stage, getStage } from 'src/helpers';

/**
 * Stages where the glossary integration feature is enabled.
 *
 * The feature is now enabled on every stage (TEST, BETA, GAMMA, PROD).
 * Keep the matching assertion in the unit test in sync with this set so
 * a careless edit cannot silently narrow the rollout.
 */
export const GLOSSARY_ENABLED_STAGES: ReadonlySet<Stage> = new Set<Stage>([
    Stage.TEST,
    Stage.BETA,
    Stage.GAMMA,
    Stage.PROD,
]);

/**
 * Returns true when the glossary feature is enabled for the current stage.
 *
 * When this returns false:
 *   - GlossaryProvider SHALL NOT request /glossary.
 *   - TermScanner SHALL NOT highlight any terms.
 */
export const useGlossaryFeatureFlag = (): boolean => {
    return GLOSSARY_ENABLED_STAGES.has(getStage());
};
